import Logger from '@/logger'
import Storage from '@/storage'

import { ACTIONS as IMPROVEMENTS } from './modules/improvements/actions'

import { MUTATIONS } from './mutations'

const ACTIONS = {

    ensureAuthContext: 'retrieve-current-auth-context-if-not-in-state',
    setRequestToken: 'set-request-token',

    updateChosenProperty: 'update-chosen-property',

    updatePartnerReferralId: 'update-partner-referral-id',

    IMPROVEMENTS,
}

export { ACTIONS }

export default {

    /**
     * Gets the authentication context from state or, failing that, local storage.
     * @returns {Context} The auth context.
     */
    async [ACTIONS.ensureAuthContext](context) {
        try {
            let cxt = context.state.authContext
            if (!cxt) {
                cxt = await Storage.context.retrieveAsync()
                Logger.logObject(cxt, 'Auth Context Ensured', 'Auth / Storage')
            } else {
                Logger.logObject(cxt, 'Auth Context Ensured', 'Auth / State')
            }
            return cxt
        } catch (err) {
            Logger.log(`Fail state on ${ ACTIONS.ensureAuthContext }`, 'Auth')
            throw err
        }
    },

    /**
     * Updates the info for the property for the app to operate on.
     * @param {Object} context
     * @param {PropertyInfo} propertyInfo If schemeInfo is null then it will not be changed from it's current state.
     * @returns {Boolean} A flag to indicate the operation completed.
     */
    [ACTIONS.updateChosenProperty](context, propertyInfo) {
        // noinspection JSUnresolvedVariable - Expected check.
        if (propertyInfo && propertyInfo.id !== undefined) {
            Logger.logObject(propertyInfo, 'Invalid object passed', 'Property')
            throw new TypeError('A property was passed, where a propertyInfo consisting of { Property and LinkedSchemeData } is expected')
        }

        try {
            if (!propertyInfo) {
                Logger.log('Clearing property data', 'Property')
                context.commit(MUTATIONS.selectProperty, null)
                context.commit(MUTATIONS.setPropertySchemeInfo, null)
            } else {
                Logger.logObject(propertyInfo, `Updating property data`, 'Property')
                context.commit(MUTATIONS.selectProperty, propertyInfo.property)

                if (propertyInfo.schemeInfo !== undefined)
                    context.commit(MUTATIONS.setPropertySchemeInfo, propertyInfo.schemeInfo)
            }
            return true
        } catch (err) {
            Logger.log(`Fail state on ${ ACTIONS.updateChosenProperty }`, 'Property')
            throw err
        }
    },

    /**
     * Set the auth token and save to the session store.
     * @param {Object} context
     * @param {string} token
     */
    async [ACTIONS.setRequestToken](context, token) {
        context.commit(MUTATIONS.setRequestToken, token)

        await Storage.session.setTokenAsync(token)

        Logger.log(`State updated ${ ACTIONS.setRequestToken }`, 'Token')
    },

    /**
     * Updates the partnerReferralId state and saves to the session store.
     * @param {Object} context
     * @param {string} partnerReferralId
     */
    async [ACTIONS.updatePartnerReferralId](context, partnerReferralId) {
        context.commit(MUTATIONS.setPartnerReferralId, partnerReferralId)

        await Storage.session.setPartnerReferralAsync(partnerReferralId)

        Logger.log(`State updated ${ ACTIONS.setPartnerReferralId }`, 'Referrals')
    },
}
